const throwWeaponDescription = `Кинжалы, сюрикены и другое метательное оружие имеют дальность броска от двадцати до тридцати футов, в зависимости от их веса и конструкции. Они требуют большой ловкости и меткости для эффективного использования.`

module.exports = throwWeaponDescription
